// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"message-form-active__visuallyhidden--eX9ll","focusable":"message-form-active__focusable--yDzKr","checkbox":"message-form-active__checkbox--KH8dV"};